// mod-people-wall

jQuery(document).ready(function () {
  jQuery(".mod-people-wall").each(function (index) {
    let slider = jQuery(this).find(
      ".people-wall-items.slider .people-wall-slider"
    );
    let dots = jQuery(this).find(
      ".people-wall-items.slider .people-wall-slider-controls"
    );
    jQuery(slider).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: false,
      autoplay: false,
      appendDots: jQuery(dots),
      //   autospeed: 5000,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  });
  jQuery('.people-wall-item .people-wall-item-image .normal-text').each(function () {
    var minHeight = jQuery(this).height() + 29;
    console.log(minHeight );
    jQuery(this).parent().css('min-height', minHeight);
  });
});
// var read_peapole_bio = document.querySelectorAll('')
document.addEventListener("DOMContentLoaded", function () {
  // Open popup
  document.querySelectorAll(".read_people_bio").forEach((button) => {
    button.addEventListener("click", function () {
      const popupId = this.getAttribute("data-id");
      document.getElementById(popupId).classList.add("active");
      jQuery("body").addClass("no-scroll");
    });
  });

  // Close popup
  document.querySelectorAll(".close_read_bio").forEach((closeBtn) => {
    closeBtn.addEventListener("click", function () {
      this.closest(".people-wall-item-popup-outer").classList.remove("active");
      jQuery("body").removeClass("no-scroll");
    });
  });

  // Close when clicking outside the popup content
  document
    .querySelectorAll(".people-wall-item-popup-outer")
    .forEach((overlay) => {
      overlay.addEventListener("click", function (e) {
        if (e.target === this) {
          this.classList.remove("active");
          jQuery("body").removeClass("no-scroll");
        }
      });
    });
});
